import { ListSchedule } from "models/list-schedule";
import { doDelete, doGet, doPatch, doPost, parseListPath } from "../request";
import { List } from "models/list";

export const adminDoGetListSchedules = async (list: List) => {
  const schedules = await doGet<ListSchedule[]>(
    parseListPath(list, "schedules"),
  );
  return schedules;
};

export const adminDoPostListSchedule = async (
  list: List,
  data: Partial<ListSchedule>,
) => {
  const schedule = await doPost<ListSchedule>(
    parseListPath(list, "schedule"),
    data,
  );
  return schedule;
};

export const adminDoPatchListSchedule = async (
  list: List,
  scheduleUuid: string,
  data: Partial<ListSchedule>,
) => {
  const schedule = await doPatch<ListSchedule>(
    parseListPath(list, `schedule/${scheduleUuid}`),
    data,
  );
  return schedule;
};

export const adminDoDeleteListSchedule = async (
  list: List,
  scheduleUuid: string,
) => {
  await doDelete(parseListPath(list, `schedule/${scheduleUuid}`));
};
